import React from 'react'
import YouTube from 'react-youtube'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'


import headerImage from 'images/analytics/header.png'
import footerImage from 'images/analytics/footer.png'
import Icon from '../../../Shared/Icon/Icon'

class ProductAnalyticsAbout extends React.Component {
  constructor(props) {
    super(props)
  }

  callToActionButton() {
    if (!this.props.guestVersion) {
      if (!this.props.analyticsParticipant) {
        return <Link to="/profile/analytics" className="btn btn-secondary">Join analytics</Link>
      }
    } else if (this.props.signedIn) {
      return <a href="/profile/upload/model" className="btn btn-secondary">Upload models and Join Analytics</a>
    } else {
      return <a href="/users/registration" className="btn btn-secondary">Register and Join Analytics</a>
    }
  }

  render() {
    const options = {
      width: '100%',
      height: '480',
      playerVars: {
        autoplay: 0,
      },
    }

    return (
      <div>
        <div className="site-page--analytics-about">
          <header className="content-header">
            <div className="row">
              <div className="col-12 col-md-6 col-xl-5 offset-xl-1">
                <div className="hero-text">
                  <h1 className="hero-text__title">Analytics</h1>
                  <p>Analytics is a set of extensive historic and real-time insights about market trends and your 3D
                    models. The insights are based on lifetime data from CGTrader: customer searches, available models
                    and orders completed on the marketplace.
                  </p>
                  {this.callToActionButton()}
                </div>
              </div>
              <div className="col-12 col-md-6 hero-image">
                <img src={headerImage} alt="Analytics" />
              </div>
            </div>
          </header>

          <div className="content-section content-section--light">
            <div className="row">
              <div className="col-12 col-xl-10 offset-xl-1">
                <h2 className="content-section__title">Key benefits</h2>
                <div className="row">
                  <div className="col-12 col-md-4">
                    <div className="benefit-box">
                      <Icon type={['fal', 'step-forward']} color="green-dark" />
                      <h3 className="benefit-box__title">Know what to model next</h3>
                      <p>See the popularity of various searches and keywords, know which models are most profitable and
                        get insights on supply and demand.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="benefit-box">
                      <Icon type={['fal', 'chart-line']} color="green-dark" />
                      <h3 className="benefit-box__title">See marketplace pricing trends</h3>
                      <p>Find out how your prices compare to other similar models. Never undervalue your work or lose
                        customers due to overpricing.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="benefit-box">
                      <Icon type={['fal', 'paint-brush']} color="green-dark" />
                      <h3 className="benefit-box__title">Understand what your portfolio needs</h3>
                      <p>Find your niche and customers. See how each of your models is performing. Get tips on how to
                        improve your model presentation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="content-section">
            <div className="row">
              <div className="col-12 col-xl-10 offset-xl-1">
                <h2 className="content-section__title">How it works</h2>
                <div className="row">
                  <div className="col-10 offset-1">
                    <YouTube
                      videoId="TDaRf5nmMY8"
                      opts={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="content-section content-section--light">
            <div className="row">
              <div className="col-12 col-xl-10 offset-xl-1">
                <h2 className="content-section__title">Who can join the program?</h2>
                <div className="row">
                  <div className="col-12">
                    <p className="info-text">Every designer who has uploaded at least 5 models on CGTrader with an
                      average publishing score of 5 or more is eligible to participate in the program. Access to
                      advanced Analytics functions is unlocked through a tier system.
                    </p>

                    <p className="info-text">
                      Analytics is a non-exclusive club of pro-sellers who want to improve their sales and get the best
                      data about the 3D marketplace. Please see the <a href="/pages/cgtrader-analytics-terms-of-service" target="_blank">
                        Terms & Conditions
                                                                    </a> for more information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!this.props.analyticsParticipant
          && (
          <div className="content-section">
            <div className="row">
              <div className="col-12 col-md-5 col-xl-4 offset-xl-1">
                <div className="footer-text">
                  <h2 className="footer-text__title">Don't Miss Out! Join now!</h2>
                  <p>Up your sales with the best data on the 3D market – only a click away!</p>
                  {this.callToActionButton()}
                </div>
              </div>
              <div className="col-12 col-md-7 col-xl-7">
                <img src={footerImage} alt="Analytics" />
              </div>
            </div>
          </div>
          )
          }

        </div>
      </div>
    )
  }
}

ProductAnalyticsAbout.propTypes = {
  analyticsParticipant: PropTypes.bool.isRequired,
  guestVersion: PropTypes.bool,
  signedIn: PropTypes.bool,
}

ProductAnalyticsAbout.defaultProps = {
}

export default ProductAnalyticsAbout
